import { render, staticRenderFns } from "./aufgabe-ergebnis-festhalten-modal.vue?vue&type=template&id=7723121d&scoped=true"
import script from "./aufgabe-ergebnis-festhalten-modal.vue?vue&type=script&lang=js"
export * from "./aufgabe-ergebnis-festhalten-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7723121d",
  null
  
)

export default component.exports